import { useState } from 'react'
import { useIntl } from 'react-intl'
import { ConfirmDeleteModal } from '../../components/generic-confirm/Confirm'
import { EditUserModal } from '../../components/users/EditUserModal'
import { ManagementUser } from '../../models/managementUsers'
import { requestManagementUserToggleStatus } from '../../requests/requests'
import { UserRole } from '../../models/models'

export function SingleUser({
  user,
  refetch,
}: {
  user: ManagementUser
  refetch: any
}) {
  const intl = useIntl()
  const [editShow, setEditShow] = useState(false)

  const toUserRoles = (roles: string[]): UserRole[] =>
    roles
      .map(role => UserRole[role as keyof typeof UserRole])
      .filter((r): r is UserRole => r !== undefined);

  const handleConfirmDisable = async () => {
    await requestManagementUserToggleStatus(user.id)
    refetch()
  }

  return (
    <tr>
      <td>
        <EditUserModal
          user={user}
          show={editShow}
          onHide={() => setEditShow(false)}
          refetch={refetch}
        />
        <div>
          <div>
            <span className='fw-bold fs-7 text-black'>{user.firstName + ' ' + user.lastName}</span>
            &nbsp;
            {user.isDisabled && <span className='ms-3 badge badge-warning'>{intl.formatMessage({ id: 'LIST_FAMILIES.DISABLED' })}</span>}
          </div>
          <div className='fw-bold fs-7 text-muted'>{user.email}</div>
        </div>
      </td>
      <td>
        <div className='fw-bold text-gray-600'>
          {user.roles}
          {toUserRoles(user.roles as any).includes(UserRole.Comercial) ? ` (${user.sageCode ? user.sageCode : '-'})` : ``}
        </div>
      </td>
      <td>
        <div className='text-end d-flex justify-content-end gap-4'>
          <span className='text-decoration-underline fw-semibold' onClick={() => setEditShow(true)}>
            {intl.formatMessage({ id: 'BUTTON.EDIT' })}
          </span>
          <span className='text-decoration-underline fw-semibold' onClick={handleConfirmDisable}>
            {user.isDisabled ? intl.formatMessage({ id: 'BUTTON.ENABLE' }) : intl.formatMessage({ id: 'BUTTON.DISABLE' })}
          </span>
        </div>
      </td>
    </tr>
  )
}
